// extracted by mini-css-extract-plugin
module.exports = {"native":"_1ogLE","label":"_1JSfU"};